export type FilterUiMode = "COMPACT" | "FULL";
export type Module = "Issue" | "Test" | "TestSet" | "Requirement";

export const mapModuleToUrlType = (module: Module): string => {
  switch (module) {
    case "Test":
      return "tests";
    case "TestSet":
      return "sets";
    case "Requirement":
      return "requirements";
    case "Issue":
      return "issues";
    default:
      throw new Error(`mapModuleToUrlType=> ${module} not supported`);
  }
};
